const SET_TRACKING_INFO = (state, data) => {
  state.countryCode = data.countryId
  state.carrier = data.carrier
}
export default {
  SET_TRACKING_INFO
}



// WEBPACK FOOTER //
// ./src/store/modules/user/tracking/mutations.js